
import { useEffect, useRef ,useState } from "react";
import { Lensflare, LensflareElement } from 'three/examples/jsm/objects/Lensflare.js';
import  Util  from "./utils";

const THREE = window.Tetavi.THREE;

const Light = (props) => {
    const [init, setInit] = useState(false);
    const [light, setLight] = useState([]);

      useEffect(() => {
          if(!init && props.light && props.scene && props.setLightUpdateables ){
            let addLight
            if(props.light.lightType == "ambient_light"){
                addLight = new THREE.AmbientLight(0x999999   );
                addLight = Util.setFromConfig(addLight,props.light)
                setLight([addLight])
                props.scene.add( addLight );
              }
              if(props.light.lightType == "spot_light"){
                addLight = new THREE.SpotLight("rgb(" + props.light.color[0].val[0] + ", " + props.light.color[0].val[1] + ", " + props.light.color[0].val[2] + ")"  );
                addLight = Util.setFromConfig(addLight,props.light)
                
                if(props.debug){
                  const spotLightHelper = new THREE.SpotLightHelper( addLight );
                  props.scene.add( spotLightHelper );
                }
                setLight([addLight])
                props.scene.add( addLight );
                
              }
              if(props.light.lightType == "hemisphere_light"){
                addLight = new THREE.HemisphereLight("rgb(" + props.light.color[0].val[0] + ", " + props.light.color[0].val[1] + ", " + props.light.color[0].val[2] + ")"  );
                addLight = Util.setFromConfig(addLight,props.light)
                
                if(props.debug){
                  const hemisphereLightHelper = new THREE.HemisphereLightHelper( addLight,5 );
                  props.scene.add( hemisphereLightHelper );
                }
                setLight([addLight])
                props.scene.add( addLight );
              }
              if(props.light.lightType == "point_light"){
                addLight = new THREE.PointLight("rgb(" + props.light.color[0].val[0] + ", " + props.light.color[0].val[1] + ", " + props.light.color[0].val[2] + ")" , 1, 100 );
                addLight = Util.setFromConfig(addLight,props.light)
                
                if(props.debug){
                  const pointLightHelper = new THREE.PointLightHelper( addLight,5 );
                  props.scene.add( pointLightHelper );
                }
                setLight([addLight])
                props.scene.add( addLight );
                

                
                if(props.light.lensflare)
                  addLensflare(addLight  );

              }
              if(props.light.lightType == "directional_light"){
                addLight = new THREE.DirectionalLight("rgb(" + props.light.color[0].val[0] + ", " + props.light.color[0].val[1] + ", " + props.light.color[0].val[2] + ")" , 1);
                addLight = Util.setFromConfig(addLight,props.light)
                
                if(props.debug){
                  const directionalHelper = new THREE.DirectionalLightHelper( addLight,5 );
                  props.scene.add( directionalHelper );
                }
                setLight([addLight])
                props.scene.add( addLight );
                

                
                if(props.light.lensflare)
                  addLensflare(addLight  );

              }
            setInit(true)
            addLight.tick = Tick
            props.lightUpdateables.push(addLight)
            props.setLightUpdateables(props.lightUpdateables)

          }
        
      }, [props.light,props.scene,props.setLightUpdateables]);

      function addLensflare(_light) {
        const textureLoader = new THREE.TextureLoader();
        const textureFlare0 = textureLoader.load( './images/lensflare0.png' );
        const textureFlare3 = textureLoader.load( './images/lensflare3.png' );

        const lensflare = new Lensflare();
        lensflare.addElement( new LensflareElement( textureFlare0, 700, 0, _light.color ) );
        lensflare.addElement( new LensflareElement( textureFlare3, 60, 0.6 ) );
        lensflare.addElement( new LensflareElement( textureFlare3, 70, 0.7 ) );
        lensflare.addElement( new LensflareElement( textureFlare3, 120, 0.9 ) );
        lensflare.addElement( new LensflareElement( textureFlare3, 70, 1 ) );
        _light.add( lensflare );

      }


      async function Tick(delta,frame){
        if(light[0].PerFrameFunctions){
            for(const lightFunc of light.PerFrameFunctions){
              
              lightFunc(light,frame)
            }
          }
      }

    return (
        <div >
        </div>
        
      );
}


export default Light;